import {
  loadRecommendationsEvents,
  loadRecommendationsOverviews,
  loadRecommendationsRoutes,
} from '@common/redux/slices/recommendation.slice';
import { useLocaleFilter } from "@common/hooks/useLocaleFilter";
import { checkLocales } from "@common/utils/locales";
import { reduxWrapper } from '@common/redux/store';
import { Places } from '@kursk/components/pages/Places/Places';
import { loadEntitiesFromQuery } from '@kursk/utils/loadEntitiesFromQuery';
import React from 'react';
import { loadPrices } from "@common/redux/slices/minAndMaxPrices.slice";

export default function PlacesPage() {
  useLocaleFilter();

  return <Places />;
}

export const getServerSideProps = reduxWrapper.getServerSideProps(async ({ store, query, res, req, ...data }) => {
  const checkResult = await checkLocales(data['resolvedUrl'], query, req, res, store);
  if (checkResult) return checkResult;

  await Promise.all([
    loadEntitiesFromQuery('places', query, store),
    store.dispatch(loadRecommendationsEvents({ locales: query.locales })),
    store.dispatch(loadRecommendationsRoutes({})),
    store.dispatch(loadRecommendationsOverviews({})),
    store.dispatch(loadPrices('places')),
  ]);

  return { props: {} };
})
